import * as i0 from '@angular/core';
import { Injectable, Component, NgModule } from '@angular/core';
import { map, takeUntil } from 'rxjs/operators';
import { BehaviorSubject, Subject } from 'rxjs';
import * as i1 from '@angular/common/http';
import * as i2 from '@angular/common';
import { PrimengLibraryModule } from 'primeng-library';

class DailyAttendanceSummaryService {
    constructor(http) {
        this.http = http;
        this.onLoadResponseSubject = new BehaviorSubject(null);
    }
    getAttendanceSummaryDetails(Id) {
        return this.http.get(`/vd/formBuilder/employee/attendanceDetails/${Id}`).pipe(map((response) => {
            if (response.status === 200) {
                this.onLoadResponseSubject.next(response);
                return response;
            }
            else {
                return null;
            }
        }));
    }
}
DailyAttendanceSummaryService.ɵfac = function DailyAttendanceSummaryService_Factory(t) { return new (t || DailyAttendanceSummaryService)(i0.ɵɵinject(i1.HttpClient)); };
DailyAttendanceSummaryService.ɵprov = i0.ɵɵdefineInjectable({ token: DailyAttendanceSummaryService, factory: DailyAttendanceSummaryService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DailyAttendanceSummaryService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }]; }, null); })();

const _c0 = function (a0, a1) { return { "absent": a0, "present": a1 }; };
class DailyAttendanceSummaryComponent {
    constructor(dailyAttendanceSummaryService) {
        this.dailyAttendanceSummaryService = dailyAttendanceSummaryService;
        this.observableSubscription$ = new Subject();
        this.attendanceSummaryDetails = [];
    }
    ngOnInit() {
        this.getLeaveSummaryDetails();
    }
    getLeaveSummaryDetails() {
        this.getAttendanceId = 'AttendanceDataId' in sessionStorage ? parseInt(sessionStorage.getItem('AttendanceDataId')) : null;
        if (this.getAttendanceId) {
            this.dailyAttendanceSummaryService.getAttendanceSummaryDetails(this.getAttendanceId).pipe(takeUntil(this.observableSubscription$)).subscribe(response => {
                this.attendanceSummaryDetails = response.data || null;
            });
        }
    }
    ngOnDestroy() {
        this.observableSubscription$.next();
        this.observableSubscription$.complete();
    }
}
DailyAttendanceSummaryComponent.ɵfac = function DailyAttendanceSummaryComponent_Factory(t) { return new (t || DailyAttendanceSummaryComponent)(i0.ɵɵdirectiveInject(DailyAttendanceSummaryService)); };
DailyAttendanceSummaryComponent.ɵcmp = i0.ɵɵdefineComponent({ type: DailyAttendanceSummaryComponent, selectors: [["daily-attendance-summary"]], decls: 16, vars: 14, consts: [[1, "container-fluid", "attendance-summary", "p-0", "m-0", "mt-2"], [1, "row"], [1, "col-4"], [1, "attendance_details_heading"], [1, "session", 3, "ngClass"]], template: function DailyAttendanceSummaryComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵelementStart(3, "p", 3);
        i0.ɵɵtext(4);
        i0.ɵɵpipe(5, "date");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "div", 2);
        i0.ɵɵelementStart(7, "p", 3);
        i0.ɵɵtext(8, " First Half : ");
        i0.ɵɵelementStart(9, "span", 4);
        i0.ɵɵtext(10);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(11, "div", 2);
        i0.ɵɵelementStart(12, "p", 3);
        i0.ɵɵtext(13, " Second Half : ");
        i0.ɵɵelementStart(14, "span", 4);
        i0.ɵɵtext(15);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(4);
        i0.ɵɵtextInterpolate1(" Date: ", i0.ɵɵpipeBind2(5, 5, ctx.attendanceSummaryDetails == null ? null : ctx.attendanceSummaryDetails.attendanceDate, "dd MMM yyyy"), " ");
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(8, _c0, (ctx.attendanceSummaryDetails == null ? null : ctx.attendanceSummaryDetails.firstHalf == null ? null : ctx.attendanceSummaryDetails.firstHalf.name) == "Absent", (ctx.attendanceSummaryDetails == null ? null : ctx.attendanceSummaryDetails.firstHalf == null ? null : ctx.attendanceSummaryDetails.firstHalf.name) == "Present"));
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1("", ctx.attendanceSummaryDetails == null ? null : ctx.attendanceSummaryDetails.firstHalf == null ? null : ctx.attendanceSummaryDetails.firstHalf.name, " ");
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(11, _c0, (ctx.attendanceSummaryDetails == null ? null : ctx.attendanceSummaryDetails.secondHalf == null ? null : ctx.attendanceSummaryDetails.secondHalf.name) == "Absent", (ctx.attendanceSummaryDetails == null ? null : ctx.attendanceSummaryDetails.secondHalf == null ? null : ctx.attendanceSummaryDetails.secondHalf.name) == "Present"));
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate(ctx.attendanceSummaryDetails == null ? null : ctx.attendanceSummaryDetails.secondHalf == null ? null : ctx.attendanceSummaryDetails.secondHalf.name);
    } }, directives: [i2.NgClass], pipes: [i2.DatePipe], styles: [""] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DailyAttendanceSummaryComponent, [{
        type: Component,
        args: [{
                selector: 'daily-attendance-summary',
                templateUrl: 'daily-attendance-summary.component.html',
                styleUrls: ['daily-attendance-summary.component.scss']
            }]
    }], function () { return [{ type: DailyAttendanceSummaryService }]; }, null); })();

class DailyAttendanceSummaryModule {
}
DailyAttendanceSummaryModule.ɵfac = function DailyAttendanceSummaryModule_Factory(t) { return new (t || DailyAttendanceSummaryModule)(); };
DailyAttendanceSummaryModule.ɵmod = i0.ɵɵdefineNgModule({ type: DailyAttendanceSummaryModule });
DailyAttendanceSummaryModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[
            PrimengLibraryModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(DailyAttendanceSummaryModule, { declarations: [DailyAttendanceSummaryComponent], imports: [PrimengLibraryModule], exports: [DailyAttendanceSummaryComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DailyAttendanceSummaryModule, [{
        type: NgModule,
        args: [{
                declarations: [DailyAttendanceSummaryComponent],
                imports: [
                    PrimengLibraryModule
                ],
                exports: [DailyAttendanceSummaryComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of daily-attendance-summary
 */

/**
 * Generated bundle index. Do not edit.
 */

export { DailyAttendanceSummaryComponent, DailyAttendanceSummaryModule, DailyAttendanceSummaryService };
//# sourceMappingURL=daily-attendance-summary.js.map
